var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"inside"},[_c('p',{staticClass:"title"},[_vm._v("วันที่เริ่ม - วันที่สิ้นสุดการให้ประกัน")]),_c('p',[_vm._v(" "+_vm._s(_vm._f("formatDateDat")(_vm.data.insuranceStart))+" ถึง "+_vm._s(_vm._f("formatDateDat")(_vm.data.insuranceEnd))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }